import { render } from "./StrategyPage.vue?vue&type=template&id=736ec712"
import script from "./StrategyPage.vue?vue&type=script&lang=js"
export * from "./StrategyPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__